import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=a47ccbe2&scoped=true&lang=pug&"
import script from "./Playground.js?vue&type=script&lang=js&"
export * from "./Playground.js?vue&type=script&lang=js&"
import style0 from "./Playground.vue?vue&type=style&index=0&id=a47ccbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47ccbe2",
  null
  
)

export default component.exports